import { handleActions } from 'redux-actions';
import { listLoaded } from './index';

export default handleActions<any, any>(
  {
    [listLoaded.toString()]: (state, action) => ({
      ...state,
      tiers: action.payload.list,
    }),
  },
  {}
);
